<template>
    <div class="Anotacoes" >
        <b-modal ref="modal-anotacoes" id="modalAnotacoes" size="xl" :hide-footer="true" :hide-header="true">
            <div class="w-100 text-end txt-size-20 txt-blue-2">
                <span @click="close"><i class="fas fa-times c-pointer"></i></span>
            </div>


            <div class="row">
                <div class="col-12">
                    <span class="txt-p txt-blue-2 txt-size-20 txt-w-bold mb-2">
                        Anotações
                    </span>
                    <p class="txt-p txt-size-16 txt-w-5 txt-grey-2">
                        Anote tudo que achar importante para lembrar mais tarde.
                    </p>
                </div>

            </div>

            <div class="row mt-3 px-5">
                <div class="col-12">
                    <div class="form-floating">
                        <textarea class="form-control" rows="5" placeholder="Nova anotação" maxlength="400" id="anotacao" v-model="anotacao" style="min-height: 100px"></textarea>
                        <label for="floatingTextarea">Nova anotação</label>
                    </div>
                </div>
                <div class="col-12 text-end mt-3">
                    <button class="btn btn-blue txt-size-14 py-2" @click="salvar">Salvar</button>
                </div>

            </div>

            <div class="mt-3 px-5">
                <hr class="" />
            </div>

            <div class="row my-3 px-5">
                <div class="col-12" v-if="anotacoes.length > 0">
                    <div class="item-anotacao mt-3" v-for="(item,index) in anotacoes" :key="index">
                        <div class="row">
                            <div class="col-11">
                                <p class="txt-p txt-size-14 txt-grey-2 mb-0">
                                    {{item.dsAnotacao}}
                                </p>
                            </div>
                            <div class="col-1 d-flex align-items-center justify-content-end">
                                <span class="icone-excluir txt-erro c-pointer" v-if="item.dsLoginInclusao == user" @click="excluir(item.idUsuarioTreinamentoAulaAnotacao)"><i class="fas fa-trash"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center" v-else>
                    <div class="bg-grey-1 rounded p-3 d-flex align-items-center justify-content-center">
                        <p class="txt-p txt-size-16 txt-w-5 txt-grey-2 mb-0">
                            Você ainda não criou nenhuma anotação para esta aula
                        </p>
                    </div>
                    
                </div>
            </div>


        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Anotacoes',
        data: function () {
            return {
                anotacoes: [],

                anotacao: null,
            }
        },
        computed: {
            user() {
                return this.$store.state.user.usuario.dsLogin
            },
        },
        props: {
            showModal: Boolean,
            hideModal: Boolean,
            idUsuarioTreinamentoAula: {
                type: Number,
                required: true,
            },
        },
        methods: {
            carregarAnotacoes() {
                let $this = this;
                if ($this.idUsuarioTreinamentoAula != null && $this.idUsuarioTreinamentoAula != 0) {
                    axios.get(`${urlApi}/UsuarioTreinamentoAulaAnotacao/Get`, { params: { idUsuarioTreinamentoAula: $this.idUsuarioTreinamentoAula } })
                        .then(res => {
                            if (res.data.success) {
                                $this.anotacoes = res.data.data.rows;
                                
                                $this.$emit('temAnotacao', $this.anotacoes.length > 0);

                            } else {
                                avisoErro("Não foi possível carregar as anotações");
                            }
                        })
                        .catch(function () {
                            avisoErro("Não foi possível carregar as anotações");
                        });
                }
            },

            salvar() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamentoAulaAnotacao`, { idUsuarioTreinamentoAula: $this.idUsuarioTreinamentoAula, dsAnotacao: $this.anotacao })
                    .then(res => {
                        if (res.data.success) {
                            avisoSucesso("Anotação criada com sucesso");
                            $this.anotacao = null;
                            $this.carregarAnotacoes();
                        } else {
                            avisoErro("Não foi possível enviar a anotação");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível enviar a anotação");
                    });
            },

            excluir(idUsuarioTreinamentoAulaAnotacao) {
                let $this = this;
                axios.delete(`${urlApi}/UsuarioTreinamentoAulaAnotacao/${idUsuarioTreinamentoAulaAnotacao}`)
                    .then(res => {
                        if (res.data.success) {
                            avisoSucesso("Anotação excluida com sucesso");
                            $this.carregarAnotacoes();
                        } else {
                            avisoErro("Não foi possível excluir anotação");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível excluir anotação");
                    });
            },
            
            close() {
                this.$refs['modal-anotacoes'].hide();
            }

        },
        created: function () {
            this.carregarAnotacoes();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-anotacoes'].show();
            },

            hideModal: function () {
                this.$refs['modal-anotacoes'].hide();
            },
            idUsuarioTreinamentoAula: function () {
                this.carregarAnotacoes();
            }
        },
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /* Anotacoes */
    .item-anotacao {
        position: relative;
        border: 1px solid #A6A6A6;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        padding: 10px;

    }
    
</style>

